<template>
  <div class="form register-startup-form">
    <div
      v-if="!registeringNewAccount"
      class="button-choose-wrapper"
      :style="{ 'padding-bottom': !registeringNewAccount ? '20px' : 0 }"
    >
      <h5 class="mt-4 mb-8" v-if="program && program.apply_text">
        {{ program.apply_text }}
      </h5>
      <login-form v-if="showAlreadyButton" :next="$route.path">
        <div slot="footer">
          <div class="splash-box-footer">
            <span class="hidden-xs">Don't have an account? &nbsp;&nbsp;</span>
            <span
              class="text-yellow"
              style="cursor: pointer"
              @click.prevent="registeringNewAccount = true"
            >
              Sign up here
            </span>
          </div>
        </div>
      </login-form>
    </div>
    <template v-if="registeringNewAccount">
      <p style="margin-bottom: 2rem" class="text-center">
        Already have a Vestbee account?
        <a class="link" href @click.prevent="registeringNewAccount = false">
          Sign in
        </a>
      </p>
      <div v-for="field in form.fields" :key="field.name">
        <input
          v-if="field.type === 'text'"
          v-model="form.data[field.name]"
          :class="{ 'has-errors': form.hasErrors(field.name) }"
          :placeholder="field.label"
          class="form-control"
          type="text"
          @keyup.enter="submit()"
        />

        <template v-if="field.type === 'password'">
          <input
            v-model="form.data[field.name]"
            :class="{ 'has-errors': form.hasErrors(field.name) }"
            :placeholder="field.label"
            class="form-control"
            type="password"
            @keyup.enter="submit()"
          />
          <password :value="form.data[field.name]" />
        </template>

        <p
          v-for="error in form.errors[field.name]"
          v-show="field.type === 'text' || field.type === 'password'"
          :key="error"
          class="text-danger"
        >
          {{ error }}
        </p>
      </div>
    </template>

    <TermsFormStartup
      v-if="registeringNewAccount"
      :all-terms-accepted.sync="allTermsAccepted"
      :show-errors="triedToSubmit"
    />

    <button
      v-if="registeringNewAccount"
      class="btn btn-primary btn-block"
      :disabled="form.submitInProgress"
      @click="submit()"
    >
      <loader v-show="form.submitInProgress" class="is-black" />
      <span v-show="!form.submitInProgress">Apply</span>
    </button>
  </div>
</template>

<script>
import { Form } from '@/utils/forms'
import { mapState } from 'vuex'
import TermsFormStartup from '@/components/users/TermsFormStartup'
import LoginForm from '@/modules/auth/LoginForm'

export default {
  components: {
    LoginForm,
    TermsFormStartup,
  },
  props: {
    program: {
      type: Object,
      required: true,
    },
    showAlreadyButton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    const self = this

    return {
      allTermsAccepted: false,
      triedToSubmit: false,
      form: new Form({
        fields: [
          { name: 'startup_name', label: 'Startup name', type: 'text' },
          { name: 'email', label: 'E-mail', type: 'text' },
          { name: 'password', label: 'Password', type: 'password' },
        ],
        onSuccess() {
          self.$emit('registered', { form: self.form })
        },
      }),
      registeringNewAccount: false,
    }
  },
  watch: {
    registeringNewAccount() {
      this.triedToSubmit = false
      this.allTermsAccepted = false
    },
  },
  created() {
    this.form.data.email = this.$route.query.email || ''
  },
  computed: {
    ...mapState({
      organization: (state) => state.organizationDetails.organization,
    }),
  },
  methods: {
    submit() {
      this.triedToSubmit = true
      if (!this.allTermsAccepted) {
        this.$message.error('Correct form errors')
        return
      }
      const url = `/organizations/${this.organization.id}/register-startup`
      this.form.setUrl(url)
      const extraData = {
        program_id: this.organization.active_program.id,
        // terms are checked at TermsForm component
        privacy_and_terms: true,
        personal_data: true,
        personal_data_communication: true,
        personal_data_partners: true,
      }
      this.form.submit({ extraData })
    },
  },
}
</script>

<style lang="scss">
.register-startup-form {
  .forgot-password {
    width: 100%;
    text-align: center;
  }
}
</style>

<style scoped lang="scss">
@import '~assets/css/colors.scss';

.register-startup-form {
  p.text-danger {
    margin-top: 0;
    font-size: 14px;
  }
}

.button-choose-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-direction: column;
  margin-bottom: 20px;

  @media (max-width: theme('screens.sm')) {
    margin-bottom: 30px;
  }

  .btn {
    margin-top: 0;
  }
}

.existing-account-btn {
  color: $bright;
  font-weight: 600;
}

.or-separator {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  color: #999999;
  margin-bottom: 10px;
}
</style>
